import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/inbox.svg';
const Inbox = () => React.createElement(IconSvg, null);
export default Inbox;
